export function isObject(obj) {
    return typeof obj === "object" && obj !== null && !(obj instanceof Array);
}
export function extend(obj, extendBy) {
    obj = obj === undefined ? {} : Object.assign({}, obj);
    Object.keys(extendBy).forEach((prop) => {
        // remove undefined props
        // extend only those values that are NOT undefined
        const originalItem = obj[prop];
        const extendItem = extendBy[prop];
        if (extendItem !== undefined) {
            if (isObject(originalItem) && isObject(extendItem)) {
                // @ts-ignore
                obj[prop] = extend(originalItem, extendItem);
            }
            else {
                obj[prop] = extendItem;
            }
        }
    });
    return obj;
}
//# sourceMappingURL=Obj.js.map